import * as React from "react"
import { Loader, Image, Divider } from "semantic-ui-react"
import sadCat from "../../core/assets/sadcat.jpg"

const NotFoundPage = () => (
  <div
    style={{
      height: "100%",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      position: "relative",
    }}
  >
    <div className="error-404">
      <Image src={sadCat} size={"large"} style={{ borderRadius: 16 }} />
    </div>
    <Divider vertical />
    <div className="error-404">
      <h1>Oh non !</h1>
      <p>
        La page que vous cherchez est introuvable. Veuillez vérifier l'URL ou
        contacter la hotline.
      </p>
    </div>
  </div>
)

export default NotFoundPage
